"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateWallAngle = exports.wallLayoutToSvg = void 0;
const tiles_1 = require("../consts/tiles");
function wallLayoutToSvg(wallLayout, backgroundDimensions) {
    const totalDimensions = wallLayout.frames.reduce((acc, frame) => {
        const frameDimensions = tiles_1.TILESIZES_TO_INCHES[frame.size];
        if (!frameDimensions)
            throw new Error('Invalid frame size');
        return {
            width: Math.max(acc.width, frame.position.x + frameDimensions.width),
            height: Math.max(acc.height, frame.position.y + frameDimensions.height),
        };
    }, { width: 0, height: 0 });
    const xDelta = (backgroundDimensions.width - totalDimensions.width) / 2;
    const yDelta = (backgroundDimensions.height - totalDimensions.height) / 2;
    return `
    <svg width="32" height="32" viewBox="0 0 ${backgroundDimensions.width} ${backgroundDimensions.height}" xmlns="http://www.w3.org/2000/svg">
      ${wallLayout.frames
        .map((frame) => {
        const frameDimensions = tiles_1.TILESIZES_TO_INCHES[frame.size];
        if (!frameDimensions)
            throw new Error('Invalid frame size');
        return `<rect width="${frameDimensions.width}" height="${frameDimensions.height}" x="${frame.position.x + xDelta}" y="${frame.position.y + yDelta}" fill="currentColor" rx="1.5" ry="1.5" />`;
    })
        .join('')}
    </svg>
  `;
}
exports.wallLayoutToSvg = wallLayoutToSvg;
function calculateWallAngle(wallNormal) {
    // Z-axis vector which is the camera vector
    const zAxis = { x: 0, y: 0, z: 1 };
    // Dot product of wallNormal and zAxis
    const dotProduct = wallNormal.x * zAxis.x + wallNormal.y * zAxis.y + wallNormal.z * zAxis.z;
    // Magnitudes of the vectors
    const magnitudeWallNormal = Math.sqrt(wallNormal.x ** 2 + wallNormal.y ** 2 + wallNormal.z ** 2);
    const magnitudeZAxis = 1; // The magnitude of the z-axis vector (0, 0, 1) is 1
    // Angle in radians
    const angleRadians = Math.acos(dotProduct / (magnitudeWallNormal * magnitudeZAxis));
    // Convert angle to degrees
    return angleRadians * (180 / Math.PI);
}
exports.calculateWallAngle = calculateWallAngle;
//# sourceMappingURL=wallLayoutUtils.js.map